(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["support-request"]) return;
  try {
    
window.onload = (function() {
    const upload = document.querySelector('.inputfile');
    const check = document.querySelector('#attachmentCheck');
    const base64Upload = document.querySelector('#file_base64');
    const contactForm = document.querySelector('#ContactForm');
    
    contactForm.addEventListener('reset', function(e) {
      base64Upload.value = ''
      check.classList.add('d-none');
    });
    
    upload.addEventListener('change', function(e) {
      if (this.files && this.files.length == 1) {
        check.classList.remove('d-none');
        var reader = new FileReader();

      	reader.readAsDataURL(this.files[0]);
      	reader.onload = function () {
          base64Upload.value = reader.result;
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      } else {
        base64Upload.value = '';
        check.classList.add('d-none');
      }
    });    
  })();

  } catch(e) { console.error(e); }
})();
})();
